const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDateRangeSelector)
    }
  }
};

export default {
  refreshOn: ({ selectedDate }) => ([selectedDate]),
  'AssignWorkerDropdown.Wrapper.HeaderWrapper': ({ isOpen, containerRef }, _, internalStateSetter) => {
    if (isOpen) return;

    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter({ isOpen: true });
    document.addEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.HeaderWrapper.LeftSide.SelectedTechButton': ({ }, outlet, internalStateSetter) => {
    outlet({ selectedTechId: null, selectedVendorId: null, selectedAdminId: null });
    internalStateSetter({ isOpen: false });
    document.removeEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.HeaderWrapper.LeftSide.SelectedVendorButton': ({ }, outlet, internalStateSetter) => {
    outlet({ selectedTechId: null, selectedVendorId: null, selectedAdminId: null });
    internalStateSetter({ isOpen: false })
    document.removeEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.HeaderWrapper.LeftSide.SelectedAdminButton': ({ }, outlet, internalStateSetter) => {
    outlet({ selectedTechId: null, selectedVendorId: null, selectedAdminId: null });
    internalStateSetter({ isOpen: false })
    document.removeEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.ContentWrapper.Content.AssignTech': ({ id }, outlet, internalStateSetter) => {
    outlet({ selectedTechId: id, selectedVendorId: null, selectedAdminId: null });
    internalStateSetter({ isOpen: false })
    document.removeEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.ContentWrapper.Content.AssignVendor': ({ id }, outlet, internalStateSetter) => {
    outlet({ selectedTechId: null, selectedVendorId: id, selectedAdminId: null })
    internalStateSetter({ isOpen: false })
    document.removeEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.ContentWrapper.Content.AssignAdmin': ({ id }, outlet, internalStateSetter) => {
    outlet({ selectedTechId: null, selectedVendorId: null, selectedAdminId: id })
    internalStateSetter({ isOpen: false })
    document.removeEventListener("mousedown", holder.closeDateRangeSelector);
  },
  'AssignWorkerDropdown.Wrapper.HeaderWrapper.LeftSide.Search': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchVal: value })
  },
  'AssignWorkerDropdown.Wrapper.HeaderWrapper.LeftSide.Search(Keydown)': ({ value }, _, internalStateSetter) => {
  },
  'AssignWorkerDropdown.Wrapper.ContentWrapper.Content.Tabs.Vendors': ({ }, _, internalStateSetter) => {
    internalStateSetter({ selectedTab: 'vendors' });
  },
  'AssignWorkerDropdown.Wrapper.ContentWrapper.Content.Tabs.Techs': ({ techs }, _, internalStateSetter) => {
    internalStateSetter({ selectedTab: 'techs' });
  },
  'AssignWorkerDropdown.Wrapper.ContentWrapper.Content.Tabs.Admins': ({ }, _, internalStateSetter) => {
    internalStateSetter({ selectedTab: 'admins' });
  }
}
